import * as React from 'react';
import { lazyHideFlexPane, lazyShowFlexPane } from 'owa-flex-pane';
import { observer } from 'mobx-react';

export interface HeaderFlexPaneProps {
    content: JSX.Element;
    title: (() => string) | string;
    onDismiss: () => any;
}

const styles = require('./HeaderPane.scss');

@observer
export default class HeaderFlexPane extends React.Component<HeaderFlexPaneProps, {}> {
    componentDidMount() {
        const { content, title, onDismiss } = this.props;

        lazyShowFlexPane.importAndExecute(
            <div className={styles.headerFlexPaneContentDiv}>{content}</div>,
            {
                headerText: title,
                onDismiss: onDismiss,
            }
        );
    }

    componentWillUnmount() {
        lazyHideFlexPane.importAndExecute();
    }

    render() {
        return null;
    }
}
